import React from 'react';
import ServicePage from '../../components/ServicePage';

const LongDistanceMoving = () => (
  <ServicePage
    seoTitle="Long Distance Moving from Washington | Navy Seals Moving"
    seoDescription="Our core service for over 20 years: long-distance moves from Washington to anywhere in the U.S. Our own trucks, our own crews, accurate estimates, and clear delivery windows. Not a broker."
    headerTitle="Long Distance Moving"
    introTitle="Coast to Coast, With One Team"
    intro={[
      "Long-distance moving is what Navy Seals Moving was built for. For over 20 years, our trucks have left Washington for every corner of the country, nearly 3,000 moves a year, handled by our own crews from the first box to the final delivery.",
      "We are not a broker, and we never subcontract your move. The team that gives your estimate, the crew that packs and loads your home, and the driver who delivers it all work for us. That's one company responsible to you the whole way, and it's the single biggest difference between us and most of what you'll find searching for movers online.",
      "Every move starts with an accurate estimate by video call or an in-person visit, upfront pricing with no surprises on moving day. From there, we build your move around your dates, including secure, climate-controlled storage in our own warehouse if your new home isn't ready yet."
    ]}
    featuresTitle="How Your Move Works"
    features={[
      {
        icon: 'icon_house',
        title: 'An Accurate Estimate First',
        text: 'By video call or an in-person visit: we look at what is actually moving, so your quote is real. No lowball numbers that grow on moving day.'
      },
      {
        icon: 'icon_group',
        title: 'Our Own Trucks & Crews',
        text: 'Your belongings ride in our fleet, handled by our employees, from Washington to your new front door. Nothing is handed off to another company.'
      },
      {
        icon: 'icon_datareport',
        title: 'Clear Delivery Windows',
        text: 'Delivery is planned around your First Available Delivery Date: the day you can meet us at the destination. Up to 1,000 miles, we aim for that date or within about 7 days; longer moves run roughly 7–10 business days from it.'
      },
      {
        icon: 'icon_easel',
        title: 'Storage If You Need It',
        text: 'Closing dates not lining up? Our secure, climate-controlled warehouse holds your belongings until your new home is ready. Same company, no handoffs.'
      }
    ]}
  />
);

export default LongDistanceMoving;
